export const NO_LEVELS_LEFT: string = '30';
// export const NO_LEVELS_LEFT = "∞";
export const MESSAGE_WHEN_ALL_LEVELS_COMPLETE: string = 'You have completed all levels';
export const MESSAGE_WHEN_CORRECT_ANSWER: string = 'Correct answer';
export const MESSAGE_WHEN_WRONG_ANSWER: string = 'Wrong answer';
export const IMAGE_FAILED_TO_LOAD: string = 'Loading you question';
export const NO_HINTS: string = 'Stay tuned for hints!';
